import { render, staticRenderFns } from "./DashboardMainTab.vue?vue&type=template&id=2c03cdcd&"
import script from "./DashboardMainTab.vue?vue&type=script&lang=js&"
export * from "./DashboardMainTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports